export default __webpack_public_path__ + "static/media/gallery_05.88e64a47.jpg";